import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lt-form-error',
  imports: [],
  template: `
    @if(message)
    {
      <p class="{{class}}">
        {{ message }}
      </p>
    }

  `,
  styles: '',
})
export class LTFormErrorComponent {
  @Input() message = '';
  @Input() class = 'text-danger';
}
